import css from 'styled-jsx/css';

const styles = css`:root {
  /* @TODO get a hold of/unify these colors...
       tell design to stop giving us a new color palatte
       with each new design...
    */
  --black: #000000;
  --dark-gray: #b3b3b3;
  --error: red;
  --success: #248647;
  --green: green;
  --lightgreen: lightgreen;
  --gray-1: #787778;
  --gray-2: #bbbbbb;
  --gray-2-5: #d8d8d8;
  --gray-3: #eeeeee;
  --gray-4: #f8f8f8;
  --gray-5: #fafafa;
  --gray-6: #ebebeb;
  --gray-footer: #4f4f4f;
  --gray-footer-text: #757575;
  --gray-black: #111111;
  --heading-gray: #505050;
  --border-gray: #c8c8c8;
  --gray-background: rgba(0, 0, 0, 0.2);
  --warning: #daaa00;

  --mmr-yellow: #f8e71c;
  --mmr-red: #b41f00;
  --module-gray: #f7f7f7;
  --module-white: #ffffff;
  --primary-bg: #eeeeee;
  --clear: transparent;

  --risk-high: #e37a00;
  --risk-low: #7c993f;
  --risk-med: #ffcc00;
  --text-fg: #3b3b3b;
  --text-header: #4c5a6a;
  --tooltip-header: #4c5a69;
  --warm-grey: #898989;
  --white: #ffffff;
  --border-line: #b8b8b8;
  --orange-button: #e17a17;

  --text-dark: #3b3b3b;
  --text-med: #4f4f4f;
  --text-light: #898989;
  --text-xlight: #c4c4c4;
  --text-disabled: #b1b1b1;

  --subtle-blue-gray: #f7f9fa;
  --trp-dark-blue: #004b71;
  --trp-light-blue: #eef7fa;
  --trp-bright-blue: #05c3de;
  --ice-blue: #24c0d8;
  --row-blue: #06c3df;
  --trp-dark-blue: #0063ad;
  --dark-blue: #054c70;
  --dark-blue-2: #043954;
  --navy-blue: #0a4c71;
  --trp-nav-dark-blue: #061937;
  --trp-bottom-footer-blue: #0c2a4d;
  --trp-link-blue: #80c8ff;
  --trp-tag-blue: #00cfec;

  --navy-gradient: linear-gradient(115deg, #054c70, #086ea1);

  /* NASU Specifc Colors */
  /* TODO [2020-08-05]: change these colors to EDDS approved colors if they are not already */
  --BYOP-header-grey: #f0f3f5;
  --BYOP-header-contents-grey: #f7f9fa;

  /* 2020 colors */
  --primary-blue: #086ea1;
  --brand-interactive-blue: #006894;
  --grey-text: #475359;
  --gray-back: #f1f1f1;
  --gray-morningstar: #6b7880;
  --gray-non-rated-star: #b4babf;
  --gray-risk-reward-bar: #e9edf0;
  --green-risk-reward-thumb: #7d9845;
  --yellow-risk-reward-thumb: #ffcf3d;
  --orange-risk-reward-thumb: #e17a17;
  --gray-header-bottom-border: #879199;
  --gray-disabled-button: #e1e5e8;
  --border-white: #d3d7da;
  --link-blue: #006894;
  --qv-header-bottom-border: #d7dbde;
  --required-error-msg: #cc1f1f;
  --no-funds-error-msg: #dd3636;

  /* Beacon colors */
  --beacon-primary: #8b57d9;
  --input-field-title: #3b4b59;
  --background-blue: #253746;
}
:root {
  --page-max-width: 1230px;
  --page-padding: 32px;
  --module-gutter: 24px;
  --half-gutter: calc(var(--module-gutter) / 2);
  --quarter-gutter: calc(var(--half-gutter) / 2);
  --module-padding: 24px;
  --mobile-padding: 4px;
  --min-content: min-content;

  /* Margin and padding should be in multiples of 8 (i.e.---8, 16, 24) */
  --element-spacing-1: 8px;
  --element-spacing-2: calc(var(--element-spacing-1) * 2);
  --element-spacing-3: calc(var(--element-spacing-1) * 3);
  --element-spacing-4: calc(var(--element-spacing-1) * 4);
  --element-spacing-5: calc(var(--element-spacing-1) * 5);
  --element-spacing-6: calc(var(--element-spacing-1) * 6);
  --element-spacing-7: calc(var(--element-spacing-1) * 7);
  --element-spacing-8: calc(var(--element-spacing-1) * 8);
  --element-spacing-9: calc(var(--element-spacing-1) * 9);
  --element-spacing-10: calc(var(--element-spacing-1) * 10);
  --element-spacing-11: calc(var(--element-spacing-1) * 11);

  --border-thin-width: 1px;
  --border-width: 2px;
  --border-radius: 5px;

  /* New II Design Pattern - Introduced 11-12-2019 */
  --page-focus-width: 544px;
  --help-focus-width: 328px;
}
:root {
  --xxxsmall-font: 10px;
  --xxsmall-font: 12px;
  --xsmall-font: 14px;
  --small-font: 16px;
  --med-font: 18px;
  --large-font: 20px;
  --xlarge-font: 24px;
  --xxlarge-font: 36px;
  --xxxlarge-font: 48px;
  --title-font: 18px;
  --label-sup-font: 100%;

  --h1-font: 32px;
  --h2-font: 20px;
  --p1: 16px;
  --p2: 14px;
  --caption-size: 12px;

  --h1-font-mobile: 24px;
  --h2-font-mobile: 18px;
  --p1-mobile: 16px;
  --p2-mobile: 14px;
  --caption-size-mobile: 12px;

  --roboto-flex-font: 'Roboto Flex', sans-serif;
  --sans-novus: 'Roboto Flex Novus';
  --condensed-font: 'Roboto Flex Condensed', 'Roboto Flex', sans-serif;
  --condensed-bold: 'Roboto Flex Condensed Bold', 'Roboto Flex Condensed',
    sans-serif;
  --serif-font: 'IBM Plex Serif', serif;
  --mono-font: 'Roboto Flex', sans-serif;

  --roboto-reg: 'Roboto Flex Reg', sans-serif;
  --roboto-italic: 'Roboto Flex Italic', sans-serif;
  --roboto-bold: 'Roboto Flex Bold', sans-serif;
  --roboto-light: 'Roboto Flex', sans-serif;
  --roboto-black: 'Roboto Flex Black', sans-serif;

  --rocky-reg: 'Rocky Reg', sans-serif;
  --rocky-light: 'Rocky Light', sans-serif;

  --regular-weight: 400;
  --bold-weight: 700;
  --light-weight: 100;
  --normal-weight: normal;

  --checkbox-height: 25px;
  --checkbox-width: 25px;
}
:root {
  --filter-width-btn-expanded: 125px;
  --filters-list-width: 1106px;
  --media-filters-list-width: 340px;
  --row-width: 50%;
  --icon-height: 50px;
  --icon-width: 18px;
  --container-padding: 0 var(--element-spacing-5);
}
.fund-list-filter {
  margin-bottom: calc(8px * 5);
  display: flex;
  position: relative;
  top: 8px;
}
.filters-list-wrapper {
  display: flex;
  flex-direction: column;
  width: 1106px;
  background-color: #f7f9fa;
}
.fund-list-filter :global(button) {
  background-color: #f0f3f5;
  border-radius: 5px;
  padding: 8px;
  line-height: 22px;
  color: #475359;
  font-weight: normal;
  width: 125px;
  height: calc(8px * 5);
}
.fund-list-filter :global(button)::before {
  content: url("data:image/svg+xml;charset=utf-8,%3Csvg width='18' height='18' viewBox='0 0 18 18' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M17.9644 0.21525C17.9026 0.084 17.7706 0 17.6251 0H0.374844C0.229342 0 0.0973403 0.084 0.0354645 0.21525C-0.0260362 0.346875 -0.00653601 0.502125 0.0860901 0.613875L7.49993 9.57825V17.625C7.49993 17.832 7.66756 18 7.87493 18H10.125C10.3323 18 10.5 17.832 10.5 17.625V9.57825L17.9138 0.613875C18.0068 0.502125 18.0259 0.346875 17.9644 0.21525Z' fill='%23006894'/%3E%3C/svg%3E");
  top: 3px;
  position: relative;
  padding-right: 8px;
}
.fund-list-filter :global(button)::after {
  content: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='14' height='7' viewBox='0 0 14 7' fill='none'%3E%3Cpath d='M7.00065 7L3.41715e-07 2.70244e-07L14 -9.53674e-07L7.00065 7Z' fill='%23006894'/%3E%3C/svg%3E");
  bottom: 2px;
  left: calc(8px * 2);
  position: relative;
}
.filters-list-wrapper :global(button) {
  background-color: #ffffff;
  padding: 8px;
  border: 1px solid #e9edf0;
  line-height: 18px;
  width: auto;
  margin: calc(8px * 2) calc(8px * 2) 0 0;
}
.filters-list-wrapper :global(button)::before,
.filters-list-wrapper :global(button)::after {
  content: none;
  padding: 0;
}
.fund-list-filter :global(.expander-sectional) {
  margin: 0;
}
.fund-list-filter :global(.expanded) {
  border: none;
  width: 1106px;
  padding: 0;
}
.fund-list-filter :global(.expanded-btn) {
  border: none;
  width: 125px;
  background-color: #f0f3f5;
}
.fund-list-filter :global(.expander-subtext) {
  display: none;
}
.filter-button-container {
  display: flex;
  flex-wrap: wrap;
}
.filter-button {
  margin: calc(8px * 2) calc(8px * 2) 0 0;
}
.filter-icon {
  width: 18px;
  height: 50px;
  background-color: #f0f3f5;
}
.row-second {
  display: flex;
}
.star-rating {
  width: 50%;
}
.assets-filter {
  padding: 0 calc(8px * 5);
  margin-bottom: calc(8px * 2);
}
.row-second {
  padding: 0 calc(8px * 5);
  margin-bottom: calc(8px * 2);
}
.fund-attrs {
  width: 50%;
  margin-left: calc(8px * 2);
}
.filter-header {
  color: #475359;
  padding-top: calc(8px * 3);
  padding-bottom: calc(8px * 2);
  border-bottom: 1.5px solid #d7dbde;
  line-height: 22px;
  font-weight: bold;
}
.matched-funds-info {
  padding-top: calc(8px * 2);
  padding-left: calc(8px * 4);
}
@media (min-width: 322px) and (max-width: 720px) {
  .matched-funds-info {
    padding-left: 8px;
  }
  .filters-list-wrapper {
    width: 340px;
  }
  .fund-list-filter {
    padding-left: calc(8px * 2);
  }
  .row-second {
    flex-direction: column;
  }
  .star-rating {
    width: 100%;
  }
  .fund-attrs {
    margin-left: 0;
    width: 100%;
  }
  .fund-list-filter :global(.expanded-btn) {
    width: 125px;
  }
}
.matched-funds-info span {
  font-weight: bold;
}
`;

export default styles;